var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _polygon, _path86, _path87, _path88, _polygon2, _polygon3, _polygon4, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _polygon5, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _polygon6, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _polygon7, _polygon8, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _polygon9, _polygon10, _polygon11, _path161, _polygon12, _path162, _polygon13, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _polygon14, _path176, _path177, _path178, _path179, _path180, _path181, _polygon15, _polygon16, _path182, _polygon17, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _polygon18, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _polygon19, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _polygon20, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _polygon21, _path221, _polygon22, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _polygon23, _polygon24, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _polygon25, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _polygon26, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCorgi404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 665.72 596.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5d371e;}.cls-2{fill:#cb965f;}.cls-3{fill:#e1bb90;}.cls-4{fill:#a59685;}.cls-5{fill:#ba7c43;}.cls-6{fill:#905d34;}.cls-7{fill:#ded2c3;}.cls-8{fill:#c6b4a1;}.cls-9{fill:#d7a675;}.cls-10{fill:#010101;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.36,79.61,1.37,63C1.37,52,2.92,40.81,1.05,30.2-3.28,5.57,5.63-3.88,30.09,1.43L48.83,21.7c-6.9-.94-15-4.7-20.49-2.34C-1.27,32.09,25.19,61.64,11.36,79.61Z",
    transform: "translate(0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M577.87,439c-.59,3.2-1.19,6.41-1.78,9.61-6.61-7.86-3.93-22.76-18.59-24.52l-4.32-10Q547,401.5,540.74,388.93c-7.56-15.44-23-15.15-36.7-18.41-.93-15.91-17.6-29-6.63-47.56,5.38-9.08-1.47-15.2-11.78-15.81-10.42.25-18.61,1.41-29.28-7.57-15.33-12.89-36-8.78-51.26,6.42-9.53,9.46-24.48,19.33-25.56,30.15-1.9,19.06-14.15,23.53-26.37,25.24-9.12,1.26-13.46,2.83-15.3,11.21l-.07.07c-5.39,6.83-12,9.67-20.48,6.12q.22,7.43.42,14.87l-12.39-8.73L298.59,379l10.49-.19,1.84.5-1.78-.58.39-18.72c17.39-2.07,37,3.33,49.35-15.35,12.79-19.27,36.67-38.4,36.43-57.34-.32-25.9,16.12-22.66,27.53-28.25,6.21-3,18.52-11,22.58,5.29.26,1.06,4,2.52,4.62,2a18,18,0,0,0,4.78-6.38c1.7-3.71,2.35-10.76,4.22-11,7.46-1.08,15.26-.47,22.87.24,8.53.8,17,2.38,25.46,3.63l.66-11.35,6-.23,10.31,8.24c-1.17,10.58.17,22.29-4,31.53-13.17,29.35,18.75,10.91,22.36,22.05.67,2.05,3.62,3.36,5.51,5-1.35.47-2.69,1.29-4.06,1.35-5,.21-10.09.16-15.14.21l9.85,7.63v0q-4.1,10.26-8.2,20.53h-8.22a21.59,21.59,0,0,0,1.18,2.57c2.38-.75,4.69-1.69,7-2.59l6.15,6.15c-.17.6-.34,1.2-.52,1.8l.54-1.78,18.37,22.55c8.29,2.51,5.81,20.63,19,14.53,9.89-4.58,4.75-13.39,1.58-20.64l0-2.13c19.57-5.14,29.85,3.31,29.91,22.61,0,13.8-20.47,6.65-19.89,12.11,1.25,11.75,9.91,22.49,13.23,34.29,10.49,37.4-21.09-6.73-21.33,10.73A7.14,7.14,0,0,0,577.87,439ZM471.76,293.87c-.22-1-.43-2-.64-3l-6.93,2.62.68,2.09Zm114.33,89.21-1.3-1.17-1.32,1.68c.53.24,1.08.7,1.58.66S585.76,383.53,586.09,383.08Z",
    transform: "translate(0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M577.87,439a7.14,7.14,0,0,1-.14-1c.24-17.46,31.82,26.67,21.33-10.73-3.32-11.8-12-22.54-13.23-34.29-.58-5.46,19.94,1.69,19.89-12.11-.06-19.3-10.34-27.75-29.91-22.61-14.15-14.16-15.67-32.91-18.58-51.15l.19-.19c.92-8.15,5.41-18.43,2.07-24-9-15.21-1.93-28.89,4.35-39.6,2.85-4.88,20.26-1.22,31.07-1.45,5.93-.13,11.86-.29,17.8-.43l10.53-4.8,6.11,5v39.7c2.48,1.93,13.4,6.2,14.26,12,2,13.4-8.37-4.84-12.37,2.87-1.36,2.63-3.76-21-9.17-5.63-7,19.75-4.05,43-4.91,64.81-.1,2.75,2.76,5.62,4.24,8.43a70.29,70.29,0,0,0,2.66-7.58c3.78-16.35,7.44-32.72,11.14-49.09l.21-.21,6.21,8.19-.28.27,22.29,34.7c-2.13,27.13-16,49.85-27.84,73.28-2,3.93-5.62,7-8.49,10.51-7.17,10.19,8.88,31.28-15.65,33.32l-11.29-6.54q-4-7.87-8-15.75Z",
    transform: "translate(0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M53.1,278.51c-5.37-12.53-14.82-24.16-8.74-39.24l.12.16,5.94-.56,12.91,7.43c4.25,9.75,4.07,25.06,22.06,17.53l.21.2c-11.39,43.9,20.79,29.21,41.07,30.53l6,.05q1,2.13,2,4.25l4.4,2,5.73,3.87c12,2.95,5.43,9.25,2.68,14.86l-.4,2.62c.71-1,1.42-2,2.12-2.93,2.72,6.73,5.43,13.47,5.9,14.65-.83-1.19,16.65-8.15,2.11-14.68l.06.05,6.49-5c2.43,4.82,5.88,9.42,6.93,14.53.73,3.5-.83,10.24-3.14,11.18-22.78,9.33-26.11,30.92-32.77,50.34-1.44,4.18-1,9-1.45,13.53,30.53-7.56,38.46,16.2,48.65,36,.56,1.08-7,6.45-11,9.64a3.39,3.39,0,0,1-3.07-.16c-9.49-6.12-22.71-14.14-30-5.3-11.92,14.54,14.35,12.15,16.33,25.86,1.41,9.7,9.94-7.26,17.31-7l0,0c21.38,3.48,24.72,19,24.69,36.84-25.07-14.43-49.87-29.36-75.27-43.18C73.72,430.76,98.3,376.71,75.1,341.6c16.07,3.78,12.71-6.32,11.29-15.49C84.47,313.75,65,314.19,66.74,297.56,67.18,293.41,70.69,275.17,53.1,278.51Z",
    transform: "translate(0)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M508,241.48l-.66,11.35c-8.48-1.25-16.93-2.83-25.46-3.63-7.61-.71-15.41-1.32-22.87-.24-1.87.27-2.52,7.32-4.22,11a18,18,0,0,1-4.78,6.38c-.63.52-4.36-.94-4.62-2-4.06-16.27-16.37-8.33-22.58-5.29-11.41,5.59-27.85,2.35-27.53,28.25.24,18.94-23.64,38.07-36.43,57.34-12.4,18.68-32,13.28-49.35,15.35q-2.31-4.9-4.6-9.81l0-.07L319,352.3c4.18-4.17,6.72-8.32-.09-12.41-3.5-11.71,10.75-23.18.46-35L314.94,268c9.56-2,11.18-.31,11,9.12,0,2.19,2.58,5.8,4.66,6.42,16.08,4.75,26.67-8.32,39.31-12,19.61-5.65,6.52-29.13,18.66-28.83,40.82,1,76.95-12.77,112.82-29.08,5.65-2.57,11.17-5.41,16.75-8.13,10.9,3.19,24.13-4.62,33.26,7l-18.89,1.56.16,2.34h12.43c-16.88,1.29-20.11,10.79-16.44,25l-4.37,8.07L514,241.25c-3.57-1.92-7.13-3.89-10.78-5.64-.19-.09-1.29,1.75-2,2.69Zm-21.29-12.32-1.6,2.43a17.28,17.28,0,0,0,3.39,1.63c.36.1,1-1,1.56-1.52ZM413.5,254.51l-.84-.46-.51,1.2a2.46,2.46,0,0,0,1,0C413.32,255.14,413.38,254.76,413.5,254.51Z",
    transform: "translate(0)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M63.33,246.3l-12.91-7.43-6.72-12,.78,12.59-.12-.16Q41.2,213,38.05,186.74c-.76-6.4-1.41-12.81-2.11-19.21,7.8-18.42-.75-41.43,16.08-57.31,8.47-8,7.69-18,3.2-26.69C49.76,73,40.28,68.24,28,73.24l-.41-.4.46.35c1.93,9.19,3.86,18.38,5.77,27.5l-20-13.25-2.52-7.83c13.83-18-12.63-47.52,17-60.25,5.48-2.36,13.59,1.4,20.49,2.34C68.6,36.24,83,54,87.35,79.28c.83,4.84,8.17,8.56,12.5,12.8l-4.26,5q-1.28,2.34-2.57,4.66a3.12,3.12,0,0,0-1.18,0l-.91-.11.49.54-2.12,4.84-2.16,1.18c-.11.22-.38.55-.32.63a7.22,7.22,0,0,0,.94.89l4.43,4.43,1.92,6.24c-.23,3.37-.47,6.73-.71,10.1l10.1-.32q2.28,5.53,4.57,11.08l4.22,1.76-5.9,10.73L89.72,138.76q-6.28-8.67-12.58-17.35l-19,15.64,15,18.1q1.08,8.39,2.17,16.78l0-.28-2.19,5.29L62.68,208.4,63.81,227l3.24,7.31,2.34,11.83ZM47,223.63c1.56-2.55,2.74-3.71,2.89-5,.12-1-1.08-2.09-1.69-3.14-1.13.83-3,1.51-3.21,2.53C44.72,219.27,45.87,220.79,47,223.63ZM64.47,169c-1,1.62-2.34,2.83-2.11,3.51a3.55,3.55,0,0,0,2.78,2,3.52,3.52,0,0,0,2.3-2.56C67.49,171.23,65.91,170.36,64.47,169ZM52.9,232.18l1.39.13,1-7.25-1.9-.17Z",
    transform: "translate(0)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M518.18,205.54c-5.58,2.72-11.1,5.56-16.75,8.13-35.87,16.31-72,30.06-112.82,29.08-12.14-.3.95,23.18-18.66,28.83-12.64,3.64-23.23,16.71-39.31,12-2.08-.62-4.7-4.23-4.66-6.42.14-9.43-1.48-11.08-11-9.12l-6.27-7.81c-4.66-7.46-9.17-15-14.11-22.27-.71-1-3.52-.62-5.35-.88l7.71,29.11-.15,3.86c-6.26,11.23-9.81,27.91-28.38,14.57-.88-.63,1.19-5.37,1.88-8.2l5.46-4.91-2.67-2.15-3.12,6.75c-9.88-3.18-8.56-11.34-8.44-19l-2.45-4.78q2.49-11.34,5-22.69l61.88-4.75h-15.2l-.06,2.58,20.9,1.71c35.19-5.63,70.28-12,105.59-16.62C464,209,491.16,207.79,518.18,205.54Z",
    transform: "translate(0)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165.34,89.46c23-15.49,44.29-35.7,69.57-45.28,33.49-12.7,33.85,8.25,26.14,34.18-6.1,20.48-9.91,40.69-35.75,44.4l-1.42-2.58-2,1.73,2.81,2.34c8.82,15.29,10,28.42-10.06,35.54l-7.89,7.59c-2.91-15.16-1.18-32.47-18.89-40.78a4.09,4.09,0,0,1-.88-1.18c8.51-37.15,17.13-42,47.69-27.46,1.75.83,6-.17,7-1.69,7.76-12.11,15.1-25.75,6.53-39.25-10.08-15.87-21.9-4.59-33.5.64C196.5,65.84,194,98,165.34,89.46Zm58.09,56.68c.35-1,.7-2,1.06-3.08l-14.2-4.92c-.08,1.22-.53,3.38-.2,3.51C214.47,143.31,219,144.69,223.43,146.14Z",
    transform: "translate(0)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M553.18,414.08l4.32,10c-18,8.67-19.52,20.63-7.19,35.44,4.19,5,14.68,6.54,9.51,16.85-6.53,34.43-25.06,53.41-62.19,47.56-3.92-.62-7.37-4.2-11-6.41,5.28-5.87,9.68-13,16-17.37,22.37-15.49,33.48-34.3,21.84-61.53C527.66,423,522.56,397.64,553.18,414.08Z",
    transform: "translate(0)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M635.2,307.1c-3.7,16.37-7.36,32.74-11.14,49.09a70.29,70.29,0,0,1-2.66,7.58c-1.48-2.81-4.34-5.68-4.24-8.43.86-21.78-2.06-45.06,4.91-64.81,5.41-15.33,7.81,8.26,9.17,5.63,4-7.71,14.39,10.53,12.37-2.87-.86-5.78-11.78-10.05-14.26-12v-39.7c28.25,17.7,32.15,47.2,35.95,76.21,1.38,10.49-1,21.47-1.67,32.23l-22.29-34.7,2,2,4.16,2.05.65.47-.48-.64-4.09-2.12-2-2.05-6.21-8.18c-.75-.89-1.49-1.79-2.24-2.69l-.67.67Z",
    transform: "translate(0)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M196.59,585.37c40.91-20.34,51.84-59,60.27-99.05.74-3.56-1-7.64-1.59-11.47-3.34,1.76-6.55,3.85-10.05,5.2-5.88,2.27-1.28,20-9.7,11.32C228,483.6,213.26,475.92,216.81,460l22.77-3.89a1.63,1.63,0,0,0,1.48.66l12.27,5.66,4.58-3.57,7.14-6.13c13.72,9-.31,19.13,1.14,28.64-.78,2.43-1.55,4.86-2.33,7.3-7.12,28.61-13.46,57.45-21.7,85.74-3.91,13.41-15,20.69-29.62,20.94l-10.34-4.94-3.64-4.65Z",
    transform: "translate(0)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M553.18,414.08c-30.62-16.44-25.52,8.93-28.76,24.55-16.19-10.57-32.93-19.41-53.26-17q-1-9.09-2-18.19l0,0,4-4c5.65-8.74-2-33.64,23-18.91,12.23,16.73,29.64,6.05,44.58,8.41Z",
    transform: "translate(0)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M165.34,89.46C194,98,196.5,65.84,214.62,57.66c11.6-5.23,23.42-16.51,33.5-.64,8.57,13.5,1.23,27.14-6.53,39.25-1,1.52-5.23,2.52-7,1.69-30.56-14.57-39.18-9.69-47.68,27.46L173.8,106,151.1,92Z",
    transform: "translate(0)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M395.34,450.71c-20.65,20.85-50.43,12.56-74.26,23.26l28.58-35.59,4.71-2.43q4-4.92,8.09-9.82c14.85,2.86,35.7-15.3,43.46,12.4l-8.27,8.41.11-.11Z",
    transform: "translate(0)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28,73.24c12.26-5,21.74-.25,27.2,10.29,4.49,8.69,5.27,18.69-3.2,26.69-16.83,15.88-8.28,38.89-16.08,57.31-5.89-27.1-26.57-50.13-22.06-80.09l20,13.25c-1.91-9.12-3.84-18.31-5.77-27.5Z",
    transform: "translate(0)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M200.73,321.67c-15-9.92,3.5-19.4.48-32.93-3,6.73-4.64,10.34-6.55,14.58-1.44-6.05-2.72-11.45-4-16.85l1.47-8.25,6.46,1.76.78,0,.79-.06,9,7.18-3.54-15.41c.6-1.93,1.21-3.86,1.81-5.8l5.25,4.23.62.48-.49-.61c-6.71-10,15.57-18.34,1.56-28.69l1.08-5.5,3.76-2.58,16.06-27.32,14.46,19L232.94,272l-5.8,1.22L224.41,276c-5.77,1.07-8.93,3.64-5.66,9.88l1,2.64L212.66,307l-4.25,7.35Zm16.76-62,.29.57.3-.56Z",
    transform: "translate(0)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M600.36,460.62l11.28,6.54,17.62,14.34c-6.53,23.59,3,54.75-30.86,65.47-26-15.46,4.85-20.86,5.17-31.07C604.15,497.53,601.6,479.06,600.36,460.62Z",
    transform: "translate(0)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M600.36,460.62c1.24,18.44,3.79,36.91,3.21,55.28-.32,10.21-31.19,15.61-5.17,31.07l-42-2.86C558.57,528.8,573,525.74,582,517c21-20.35,5.65-48.12,10.3-72.17Q596.35,452.75,600.36,460.62Z",
    transform: "translate(0)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M528.7,241.42c-3.67-14.19-.44-23.69,16.44-25H532.71l-.16-2.34,18.89-1.56c21.16,4.84,42.4,9.37,63.4,14.85,3.37.88,5.63,6,8.4,9.19l-10.53,4.8-79-17.26,17.18,11.37Z",
    transform: "translate(0)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.22,205.94l-16.06,27.32c3.53-20.14-20.88-12.13-24.88-24.69l.12-16.52,12.78,1.85,3.42-15.64-7.69-.48-2.07,0q2.92-5.19,5.86-10.37l7.88-7.59C217.55,176.92,220.44,194.08,235.22,205.94Z",
    transform: "translate(0)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M95.59,97.05l4.26-5h4.05l2.15,0,8.07-6.23,8.33,1.5,12.32,2.72c13.48,6-16,32.28,14.34,30.28l2.54,3.92q-1.23,6.65-2.45,13.27l-4.14,1.56-6.31,1.74c-8.43-3.67-11.2,2.24-13.91,8.24q-1.47-12.27-2.93-24.55,2.15-11,4.28-22,.93-4.44,1.85-8.88l-6-2.21-5.82,14.61-12.32-4Z",
    transform: "translate(0)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M559.82,476.38c5.17-10.31-5.32-11.82-9.51-16.85-12.33-14.81-10.76-26.77,7.19-35.44,14.66,1.76,12,16.66,18.59,24.52Z",
    transform: "translate(0)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M349.66,438.38,321.08,474l-57.22,14.68c.78-2.44,1.55-4.87,2.33-7.3A64.85,64.85,0,0,0,305,456.54l2.32.45c4.75,5,8.6,6.32,10-2.47l14.25-6.22,4.22-4v0Z",
    transform: "translate(0)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M196.34,499.75l20.81,1.88c-10.2,15.19,27.23,34.13-3.85,47-1.13.47-5.9-7.83-9-12Q200.34,518.17,196.34,499.75Z",
    transform: "translate(0)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M53.1,278.51c17.59-3.34,14.08,14.9,13.64,19.05C65,314.19,84.47,313.75,86.39,326.11c1.42,9.17,4.78,19.27-11.29,15.49C58.27,323.87,59.43,299.88,53.1,278.51Z",
    transform: "translate(0)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M149.11,120.33c-30.34,2-.86-24.3-14.34-30.28L151.1,92,173.8,106Z",
    transform: "translate(0)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M469.16,403.4q1,9.09,2,18.19l-28.4,14.8-3.65.11L435.45,439l-5.53-2.62C439.47,421.18,451,408.32,469.16,403.4Z",
    transform: "translate(0)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M232.94,272,249.68,225l8.08,4.47c-3.12,5.3-6.81,10.39-8.81,16.08-.34,1,6.55,4.49,10.1,6.82l2.45,4.78c-10.54,3.22-8.93,21.66-24,19.16l-2.25,0,0,0Z",
    transform: "translate(0)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M629.26,481.5l-17.62-14.34c24.54-2,8.49-23.13,15.66-33.32C659.12,448.45,623.14,465.84,629.26,481.5Z",
    transform: "translate(0)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M429.92,436.37l5.53,2.62c-13.69,18.73-28.73,21.89-37.8,7.95q4.14-4.2,8.26-8.41C416,460.64,421.87,436.53,429.92,436.37Z",
    transform: "translate(0)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M200,540.59l-1,20.68-18.62-1.44,5.43-4.88-3.55-2.21,13.73-10,4.46-2.18Z",
    transform: "translate(0)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M259.05,252.32c-3.55-2.33-10.44-5.84-10.1-6.82,2-5.69,5.69-10.78,8.81-16.08l6.28.21Q261.55,241,259.05,252.32Z",
    transform: "translate(0)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M331.56,229.17l-20.9-1.71.06-2.58h15.2l22.24,1.84.12,2.45Z",
    transform: "translate(0)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M192.49,577.22l.09,9c-.84,1.9-1.69,3.81-2.53,5.72a2,2,0,0,0-.23,1.74L181.93,590l-.33-8.46Z",
    transform: "translate(0)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M198.43,563.43l2.87,0,5.22,4.52-12.12,5.56-4.66-1.72-.3-3.25Z",
    transform: "translate(0)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M189.74,571.75l4.66,1.72-1.91,3.75-10.89,4.35-4-2.93,10.46-9.12Z",
    transform: "translate(0)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M202.2,590.39l10.34,4.94-17.75,1.12,1.51-2.24c.33-1.41.67-2.82,1-4.22l.4.34.51-.15Z",
    transform: "translate(0)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M177.59,578.64l4,2.93.33,8.46C180.1,586.38,167.35,586.88,177.59,578.64Z",
    transform: "translate(0)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M122.45,87.33l-8.33-1.5Z",
    transform: "translate(0)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M182.23,552.74l3.55,2.21-5.43,4.88C181,557.47,181.6,555.1,182.23,552.74Z",
    transform: "translate(0)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189.82,593.7a2,2,0,0,1,.23-1.74l3,.29,3.23,2-1.51,2.24Z",
    transform: "translate(0)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M224.64,124.25l-2.81-2.34,2-1.73,1.42,2.58A6,6,0,0,1,224.64,124.25Z",
    transform: "translate(0)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M439.11,436.5l3.65-.11Z",
    transform: "translate(0)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M395.34,450.71l2.42-3.88Z",
    transform: "translate(0)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M200.42,540.6,196,542.78Z",
    transform: "translate(0)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M106.05,92.06l-2.15,0Z",
    transform: "translate(0)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M189.74,571.75l-1.69-2.23a1.65,1.65,0,0,1,1.39-1Z",
    transform: "translate(0)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M469.16,403.4h0l0,0Z",
    transform: "translate(0)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M317.3,378.79h0v0Z",
    transform: "translate(0)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M302.94,339.81h0Z",
    transform: "translate(0)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M528.7,241.42l22.18-5.93L533.7,224.12l79,17.26c-5.94.14-11.87.3-17.8.43-10.81.23-28.22-3.43-31.07,1.45-6.28,10.71-13.4,24.39-4.35,39.6,3.34,5.61-1.15,15.89-2.07,24.05l-.61-.42.42.6c2.91,18.24,4.43,37,18.58,51.15,0,.71,0,1.42,0,2.13-7.32.47-17.93-10.12-20.55,6.11l-18.37-22.55,0,0-6.15-6.15v0q4.1-10.27,8.2-20.53l2.56,1.5.45-1.14-3-.34L529,309.64c5.05-.05,10.1,0,15.14-.21,1.37-.06,2.71-.88,4.06-1.35-1.89-1.65-4.84-3-5.51-5-3.61-11.14-35.53,7.3-22.36-22.05,4.15-9.24,2.81-20.95,4-31.53Z",
    transform: "translate(0)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M496.15,380.52l7.89-10c13.67,3.26,29.14,3,36.7,18.41C525.79,386.57,508.38,397.25,496.15,380.52Z",
    transform: "translate(0)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M555.21,366.48c2.62-16.23,13.23-5.64,20.55-6.11,3.17,7.25,8.31,16.06-1.58,20.64C561,387.11,563.5,369,555.21,366.48Z",
    transform: "translate(0)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M508,241.48l-6.74-3.18c.67-.94,1.77-2.78,2-2.69,3.65,1.75,7.21,3.72,10.78,5.64Z",
    transform: "translate(0)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M530.67,337.76c-2.34.9-4.65,1.84-7,2.59a21.59,21.59,0,0,1-1.18-2.57h8.22Z",
    transform: "translate(0)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M471.76,293.87l-6.89,1.75-.68-2.09,6.93-2.62C471.33,291.9,471.54,292.88,471.76,293.87Z",
    transform: "translate(0)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M305.34,384.93,298.59,379Z",
    transform: "translate(0)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M586.1,383.11c-.34.42-.67,1.1-1.05,1.14s-1-.42-1.58-.66l1.32-1.68C585.23,382.3,585.66,382.69,586.1,383.11Z",
    transform: "translate(0)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M309.14,378.74l1.78.58-1.84-.5Z",
    transform: "translate(0)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M536.84,343.93l-.54,1.78c.18-.6.35-1.2.52-1.8Z",
    transform: "translate(0)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M63.33,246.3l6.06-.13,10-3,7.73.21,19.09,2.4,14-4.08c6.15-9.86,9.95-.35,14.65,1.77l6.11,7.47,8.3,3.58,7.88-.59L155,262.12l-3.95,3.78-.06,0-2.52,2.37,2.34,1.29,4.36,2.65a10,10,0,0,1,.3,1.54l-9.15,16.76-3.27,6.41-4,3.94-4.4-2v-6.21q4.09-8.36,8.2-16.72c-9.22-13-7.74,5.61-13,4.4l.86,7.16-4.13,7.07C106.39,293.24,74.21,307.93,85.6,264l2.06-2,.46-.68-.69.45-2,2.06C67.4,271.36,67.58,256.05,63.33,246.3Z",
    transform: "translate(0)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.48,239.43l-.78-12.59,6.72,12Z",
    transform: "translate(0)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M139.11,300.88l4-3.94,3.71-.81,1.35,2.89-3.3,5.73Z",
    transform: "translate(0)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M134.71,292.65v6.21q-1-2.12-2-4.25l0,.06,2-2Z",
    transform: "translate(0)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M147.52,319.61l1.72-.31c-.7,1-1.41,1.95-2.12,2.93Z",
    transform: "translate(0)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M237.47,276.26c15.1,2.5,13.49-15.94,24-19.16-.12,7.63-1.44,15.79,8.44,19l.33.32c-.69,2.82-2.76,7.56-1.88,8.19,18.57,13.34,22.12-3.34,28.38-14.57,7.67,10.21-.43,19.28-2.09,28.81q2,13.35,4,26.71c-2.5,9.27-13.37-10.88-14.26,4.05l0,0-20.13,28.4-.69.68c-1.43,2.66-3.06,5.24-4.27,8-3.48,7.91-6.79,15.89-10.16,23.84l-5.87-13.91-2-8,4.12-.12c6.7,4.42,7.2-.67,8-5.23-.08-.94-.16-1.89-.25-2.84l-16-1.51-2.72,2,6.8,3.71-.09-.09.15,4.1-14.33-4.3,1.89-7.93,4.21-6.26h0c6.95-4.65,17.55-7.88,20-14.26,4-10.43,2.89-22.91,3.56-34.55,0-.69-3.2-2.41-4.76-2.24-23.94,2.51-30,23-39.69,39.8-21.41,6.12-15.36-6.29-11.59-17.16l7.68-7.32,6.48-5.12,7.84-4.56,3.44-2.58-.09-3.27,13.28-12.35.37.38-.41-.34,0-2.06-1-4.12Zm24.46,57.38.42.43-.46-.39-.38-.44Zm-11.48,18.6,3.53.08,1.86-11.59-3.22-.52Q251.54,346.23,250.45,352.24Z",
    transform: "translate(0)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.38,376.54l5.87,13.91c3.37-7.95,6.68-15.93,10.16-23.84,1.21-2.75,2.84-5.33,4.28-8h1.09l-.41-.67,20.13-28.4.43.45-.47-.41c.89-14.93,11.76,5.22,14.26-4.05L303,339.82l-4-.11-2-2.07-2.07-2L293.64,333l-1.14.84,2.16,2,2,2.09,2.05,2c-10,5.83-31.7,1-22.49,24.5l0,6.18h0l-6.78-2.23L282.93,381c-7.06,8.88-8.45,8.84-12.35-.34-13.65,27.41-20.31,33-31.59,24.49,1,3.64,1.72,6.06,2.41,8.49-.58,5.66-1.15,11.32-2.33,22.86,3.14-12.32,6-7.64,8.71-6.09-.06,1-.11,2-.16,3.08s-.12,1.85-.17,2.78l-9.07,4.14-3.89-7.78c.18-1.46.37-2.92.55-4.39q-1.92-11.4-3.82-22.82l-.1-.05,2.17,0,6.27-12.18-16.46,3.84q-4.29-11.29-8.6-22.59l4.23-6,2.08-2,4.09-.11,4.2,4.19.06.05,4.55,2.06Z",
    transform: "translate(0)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M231.22,405.42q1.91,11.41,3.82,22.82c-.36,1.49-.71,3-1.07,4.47-12.75,3.71.34,7.18.1,10.76l5.23,7,.29,5.64L216.81,460C191,452.3,193.72,436,204,417.5q.87-5.83,1.72-11.68l5.91-19c-.33-2-.65-4-1-5.95l2.41.13,1.68-1.52-1.46-1c.39-1.34.79-2.69,1.18-4q4.31,11.29,8.6,22.6a9.89,9.89,0,0,0,1.7.36l6,4.21Z",
    transform: "translate(0)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M212.32,338.83C222,322,228.07,301.54,252,299c1.56-.17,4.8,1.55,4.76,2.24-.67,11.64.49,24.12-3.56,34.55-2.47,6.38-13.07,9.61-20,14.25l-4.2,6.26Z",
    transform: "translate(0)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M148.14,299l-1.35-2.89q-.21-2.81-.44-5.6l9.15-16.76,1.6-.5-1.9-1-4.36-2.65.18-3.66.06,0,3.95-3.78,2.13-8.21,17.08-1.86,12.18-.6,1.68,1.28-6.55,8.52a20.41,20.41,0,0,1-2,.4c-6.37-2.16-12.62-4-14.32,5.65.21.94.42,1.88.64,2.82l1.41-2.08,11,4.79,3.8-2.73,1.9-1.8,5.9-4.49,17.51,2.12c-.6,1.94-1.21,3.87-1.81,5.81q-2.7,4.11-5.42,8.22l-.79.06-.78,0L195,274.76l-2.88,3.46-1.47,8.25-14.9,0L170,280.38l-5.47,3.1,4.63.38,6.63,2.63c-6.2,2-.06,16.32-12.29,12.28l-4.3-2.17Zm18.91-5.17.69.27-.47-.94Z",
    transform: "translate(0)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M255.27,474.85c-3.34,1.76-6.55,3.85-10.05,5.2-5.88,2.27-1.28,20-9.7,11.32C228,483.6,213.26,475.92,216.81,460,191,452.3,193.71,436,204,417.51h0q.87-5.83,1.72-11.68l-15.57-4.41h0l15.57,4.41,5.91-19-14.79.47,3.47-4.38h0l-3.47,4.38,14.79-.47c-.33-2-.65-4-1-5.95q-4.12-10.25-8.27-20.48h0q4.14,10.23,8.27,20.48l2.41.13.22-2.48c.39-1.34.79-2.69,1.18-4l4.23-6,2.08-2,4.09-.11c.68-.07,1.35-.16,2-.27a7.2,7.2,0,0,1,.17-1.79l1.89-7.93-16.67-17.5c-21.41,6.12-15.36-6.29-11.59-17.16-15-9.92,3.5-19.4.48-32.93-3,6.73-4.64,10.34-6.55,14.58-1.44-6.05-2.72-11.45-4-16.85l-14.9,0h0c-6.2,2-.06,16.32-12.29,12.28l.06,4.47,4.35,1.74,9.85,0-6,14.24c-2-4.73-3.3-7.6-4.55-10.47l-6.1-1.81-2-10.36-11,2.42-3.3,5.73c12,2.95,5.43,9.25,2.68,14.86l1.72-.31c2.72,6.73,5.43,13.47,5.9,14.65-.83-1.19,16.57-8.12,2.19-14.64l6.47-5c2.43,4.82,5.88,9.42,6.93,14.53.73,3.5-.83,10.24-3.14,11.18-22.78,9.33-26.11,30.92-32.77,50.34-1.44,4.18-1,9-1.45,13.53,30.53-7.56,38.46,16.2,48.65,36,.56,1.08-7,6.45-11,9.64a3.39,3.39,0,0,1-3.07-.16c-9.49-6.12-22.71-14.14-30-5.3-11.92,14.54,14.35,12.15,16.33,25.86,1.41,9.7,9.94-7.26,17.31-7l0,0c21.31,3.5,24.65,19,24.62,36.83l0,.06,20.81,1.88c-10.2,15.19,27.23,34.13-3.85,47-1.13.47-5.9-7.83-9-12l-4.34,4-1,20.68-.54,2.16,2.86,0,5.23,4.52-12.12,5.56-1.91,3.75c0,3,.06,6,.1,9l4-.87c40.91-20.34,51.84-59,60.27-99.05C257.6,482.76,255.86,478.68,255.27,474.85Zm-99.41-153,1.36-2.37c-.09.92-.19,1.84-.28,2.76Zm52.55,26.05,3.85-3.27,1.08,1.34-4.61,2.25-.5.53-.35-.35Zm9,9.31-15,3.1-13-11.6Zm-38.88,5.35.36-.69.35.7Zm3.5-10.36c-.27,1.2-.55,2.4-.83,3.61a5.47,5.47,0,0,1-.75-.46c.44-1.12.94-2.2,1.43-3.3l.63-.46Zm-4.14-47.3.13-5.71-.49-4.39,2.45,2C185.23,301.14,183.23,303.47,177.85,304.89Zm13.26,114.83c.29.26.6.51.9.73C191.71,420.23,191.4,420,191.11,419.72Z",
    transform: "translate(0)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M134.74,292.63l0,0q4.09-8.36,8.2-16.72L130.8,287.49l-4.13,7.07,6,.05,0,.06Z",
    transform: "translate(0)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M202.49,360.37,189.36,348.7l28,8.5-15,3.11Z",
    transform: "translate(0)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M243.38,376.54l-9.68-3.92-4.54-2.06-.06-.05c-.73-1.49-1.45-3-2.17-4.46a7.2,7.2,0,0,1,.17-1.79l14.33,4.3-.06-.06Z",
    transform: "translate(0)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M177.76,304.92c-1.76,4.2-3.53,8.41-6,14.32-2-4.73-3.3-7.6-4.55-10.47.22-1.26.44-2.53.67-3.79l10,0Z",
    transform: "translate(0)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M159.16,296.6l4.3,2.17.06,4.46q-1.22,1.86-2.41,3.73Z",
    transform: "translate(0)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M179.94,296.84c5.32,4.33,3.27,6.66-2.18,8.08l.08.08c0-1.94.09-3.88.14-5.83Z",
    transform: "translate(0)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M193.07,592.25l-3-.29c.84-1.91,1.69-3.82,2.53-5.72l4-.87,2,.37-.33,4.44-.51.15-.4-.34Z",
    transform: "translate(0)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M208.41,347.89l3.85-3.27,1.08,1.34-4.61,2.25Z",
    transform: "translate(0)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M161.11,307q1.2-1.87,2.41-3.73l4.35,1.75-.66,3.79Z",
    transform: "translate(0)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M179.94,296.84l-2,2.33c-.16-1.46-.33-2.92-.49-4.38Z",
    transform: "translate(0)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M206.52,567.91l-5.22-4.52Z",
    transform: "translate(0)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M226.93,366.05c.72,1.49,1.44,3,2.17,4.46l-4.2-4.19C225.58,366.25,226.25,366.16,226.93,366.05Z",
    transform: "translate(0)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M157.25,319.27l-.31,3-1.08-.39,1.45-2.52Z",
    transform: "translate(0)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M182,352.19l-.84,3.61a5.47,5.47,0,0,1-.75-.46c.44-1.12.94-2.2,1.43-3.3Z",
    transform: "translate(0)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "179.2 362.56 178.49 362.55 178.85 361.86 179.2 362.56"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M213.32,378.52l1.46,1L213.1,381C213.17,380.18,213.24,379.35,213.32,378.52Z",
    transform: "translate(0)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M220.81,366.43l-2.08,2Z",
    transform: "translate(0)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M208.73,348.21l-.5.53-.35-.35.53-.5Z",
    transform: "translate(0)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "181.84 352.04 182.47 351.58 181.99 352.19 181.84 352.04"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "190.15 401.32 189.74 400.93 190.09 401.38 190.15 401.32"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "171.66 462.89 172.1 462.4 171.63 462.85 171.66 462.89"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M303,339.82l-4.23-14.29q-2-13.36-4-26.71l24.73,6.09c10.29,11.8-4,23.27-.45,35l-16-.08Z",
    transform: "translate(0)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M319.41,304.91l-24.73-6.09c1.66-9.53,9.76-18.6,2.09-28.81l.15-3.86c4.21-1.4,3.59-12.31,11.75-6l6.27,7.81Z",
    transform: "translate(0)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M302.94,339.81l16,.08c6.8,4.09,4.26,8.24.08,12.41L305,350.14l0,.07Q303.94,345,302.94,339.81Z",
    transform: "translate(0)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M305,350.14,319,352.3Z",
    transform: "translate(0)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M486.74,229.16l3.35,2.54c-.53.54-1.2,1.62-1.56,1.52a17.28,17.28,0,0,1-3.39-1.63Z",
    transform: "translate(0)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M413.5,254.51c-.12.25-.18.63-.37.71a2.46,2.46,0,0,1-1,0l.51-1.2Z",
    transform: "translate(0)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M121.91,124.51q1.47,12.27,2.93,24.55l6,12.19,1.65,4.37q2.85,7.81,5.71,15.62v-.06l2.85,23.12q-.84,10.72-1.67,21.44l-3,5.21-6,.54Q123,218.65,115.6,205.81c9.29-13.67,4.73-24.08-7.66-32.67l-17.33-3.68c9.1-3.84,17.56-4.14,15.47-14.11a3.44,3.44,0,0,0,.31-1.7l5.9-10.73,5.61-22.79Zm-11.45,44.18-.69-.47-.1.73Z",
    transform: "translate(0)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M73.19,155.15l-15-18.1,19-15.64q6.3,8.67,12.58,17.35Z",
    transform: "translate(0)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.19,155.15l16.53-16.39,16.67,14.89a3.44,3.44,0,0,1-.31,1.7l-18.69,9.71a2.52,2.52,0,0,0-1.66.78l-2.62,2.6-7.75,3.49Q74.26,163.55,73.19,155.15Z",
    transform: "translate(0)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M75.36,171.93l7.75-3.49L82,178.86l-5,9.26-1,3.56c.28,2.18.57,4.37.85,6.56l-4.08,24-2.56.22-2.78-1.79q-2.37-6.15-4.76-12.3l10.53-31.46,2.19-5.29Z",
    transform: "translate(0)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M103.87,102.07l12.32,4c.13,3.31.27,6.62.4,9.93l-8.52,25.15c-1.53-3.69-3-7.39-4.58-11.07,8.28-14.16-8.58-4.31-9.38-9.79l-1.92-6.24C99.81,113.69,104.53,110.5,103.87,102.07Z",
    transform: "translate(0)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M79.43,243.15l-10,3-2.34-11.83c.53-2.4,1.07-4.79,1.61-7.19Z",
    transform: "translate(0)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M103.87,102.07c.66,8.43-4.06,11.62-11.68,12l-4.43-4.43a6.48,6.48,0,0,0-.62-1.52c.72-.39,1.44-.79,2.16-1.17h4.53L93,101.71q1.29-2.33,2.57-4.66Z",
    transform: "translate(0)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M94.11,120.3c.8,5.48,17.66-4.37,9.38,9.79l-10.09.31C93.64,127,93.88,123.67,94.11,120.3Z",
    transform: "translate(0)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M108.07,141.16,116.59,116c.44,0,.88.11,1.32.19,0,1.31,0,2.61,0,3.92l-5.61,22.79Z",
    transform: "translate(0)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.68,208.4q2.38,6.15,4.76,12.3c-.24,2-.48,4.05-.73,6.07l-2.9.26Z",
    transform: "translate(0)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47,223.63c-1.11-2.84-2.26-4.36-2-5.6.22-1,2.08-1.7,3.21-2.53.61,1.05,1.81,2.17,1.69,3.14C49.72,219.92,48.54,221.08,47,223.63Z",
    transform: "translate(0)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.47,169c1.44,1.36,3,2.23,3,3a3.52,3.52,0,0,1-2.3,2.56,3.55,3.55,0,0,1-2.78-2C62.13,171.83,63.44,170.62,64.47,169Z",
    transform: "translate(0)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.9,232.18l.46-7.29,1.9.17-1,7.25Z",
    transform: "translate(0)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M93,101.71l.81,5.24H89.3q1-2.43,2.12-4.85l.42-.43A3.12,3.12,0,0,1,93,101.71Z",
    transform: "translate(0)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M63.81,227l2.91-.26c.73.14,1.46.26,2.2.39h-.26c-.54,2.4-1.08,4.79-1.61,7.19Z",
    transform: "translate(0)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.4,171.65l-2.19,5.29Z",
    transform: "translate(0)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M87.14,108.11a6.48,6.48,0,0,1,.62,1.52,7.22,7.22,0,0,1-.94-.89C86.76,108.66,87,108.33,87.14,108.11Z",
    transform: "translate(0)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M91.42,102.09l-.49-.54.91.11Z",
    transform: "translate(0)"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "28.07 73.19 27.61 72.84 28.02 73.24 28.07 73.19"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M308.67,260.19c-8.16-6.35-7.54,4.56-11.75,6L289.21,237c1.83.26,4.64-.15,5.35.88C299.5,245.18,304,252.73,308.67,260.19Z",
    transform: "translate(0)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M269.94,276.07l3.12-6.75,2.67,2.15-5.46,4.91Z",
    transform: "translate(0)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M149.11,120.33,173.8,106l13.13,19.41a3.89,3.89,0,0,0,.87,1.18q2.65,10.22,5.32,20.44l1.74,7.45-4.78,6.93-4-.32L168,151l-2.83-3.53-.09-.19-1.66-2.35-2.61-2.95q-1.78-4.62-3.55-9.24l3.21-5.73-8.86-2.71Zm18.48,8.19-.57-.44.45.55.55.45Z",
    transform: "translate(0)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M193.11,147,187.8,126.6c17.71,8.31,16,25.62,18.89,40.78l-5.86,10.37-4.1-.17c-.25-.56-.47-1.12-.68-1.69.85-2.86,1.71-5.72,2.56-8.58C206.79,157.84,200.68,152.24,193.11,147Z",
    transform: "translate(0)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M223.43,146.14c-4.47-1.45-9-2.83-13.34-4.49-.33-.13.12-2.29.2-3.51l14.2,4.92C224.13,144.09,223.78,145.11,223.43,146.14Z",
    transform: "translate(0)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M635.2,307.1l-2.7-2.23.67-.67c.75.9,1.49,1.8,2.24,2.69Z",
    transform: "translate(0)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M647.54,319.41l-4.16-2.05.24-.24,4.09,2.12Z",
    transform: "translate(0)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M643.38,317.36l-2-2,.28-.27,2,2Z",
    transform: "translate(0)"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "647.71 319.24 648.2 319.88 647.54 319.4 647.71 319.24"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M247.62,433.49c0-1,.1-2.06.16-3.09q-.1-5.29-.19-10.6c16.49-16.74,15.54,9.53,25,10.14-.66,22.79,26.71,11.49,32.37,26.6a64.85,64.85,0,0,1-38.77,24.81c-1.45-9.51,12.58-19.62-1.14-28.64l-13.26-2.29c-2.69-4.41,9.77-11.22-2.25-14.15Z",
    transform: "translate(0)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M251.79,450.42l13.26,2.29-7.14,6.13-4.72-1,.14,4.55-12.26-5.66q1.27-3,2.57-6Z",
    transform: "translate(0)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M243.64,450.72q-1.29,3-2.57,6a1.63,1.63,0,0,1-1.49-.66c-.09-1.88-.18-3.76-.28-5.64l.63-3.77c.16-.27.47-.56.44-.81a10.71,10.71,0,0,0-.44-1.73l-2-2.36a1.54,1.54,0,0,0-.55-1.41l.95,0,9.07-4.15a17.71,17.71,0,0,1,.31,1.77Q245.69,444.38,243.64,450.72Z",
    transform: "translate(0)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.33,462.41l-.14-4.55,4.72,1Z",
    transform: "translate(0)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M198.22,590.18l.33-4.44,3.65,4.65Z",
    transform: "translate(0)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M469.12,403.43l4-4Z",
    transform: "translate(0)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M354.37,436q4-4.92,8.09-9.82Q358.41,431,354.37,436Z",
    transform: "translate(0)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M194.28,208.57c4,12.56,28.41,4.55,24.88,24.69l-3.76,2.58-6.51-.67c-8-16.92-23.38-12.19-37-12.46l-4.24-3.82.62-5.72,5.68-2.43.79.08h.8l2.37,2.6c.67-1.62,1.35-3.23,2-4.85L186,206.5Z",
    transform: "translate(0)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M207.38,265.93l-17.51-2.12-8.32-2.56,6.55-8.52,5.69-1.81,5.84-3.85,2.59-1.39,2.59-1.9.23.06,3.85-2.37,5.43-.13c14,10.35-8.27,18.73-1.56,28.69l-.13.13Z",
    transform: "translate(0)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M222.73,304.67l-7.84,4.56-.75-.76L212.7,307l0,0,7.11-18.52,6.31,10.35.09,3.27Z",
    transform: "translate(0)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M226.08,298.82l-6.31-10.35c-.34-.88-.68-1.76-1-2.63l10.08-1.73,10.51.34,0,2.06,0,0Z",
    transform: "translate(0)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M200.15,280q2.72-4.11,5.42-8.22l3.54,15.4Z",
    transform: "translate(0)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M228.84,284.11l-10.08,1.73c-3.28-6.25-.12-8.82,5.65-9.89Z",
    transform: "translate(0)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M228.84,284.11,224.41,276l2.73-2.69,8.12,3,0,0,3.17,4.11,1,4.12Z",
    transform: "translate(0)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M214.32,241.34l-5.43.13v-6.3l6.51.67Z",
    transform: "translate(0)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M192.12,278.22l2.88-3.46,3.58,5.22Z",
    transform: "translate(0)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M214.89,309.23l-6.48,5.12,4.25-7.36,0,0,1.44,1.44Z",
    transform: "translate(0)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M235.26,276.27l-8.12-3,5.8-1.22Z",
    transform: "translate(0)"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "217.49 259.68 218.08 259.69 217.78 260.25 217.49 259.68"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "212.76 270.02 213.25 270.63 212.63 270.16 212.76 270.02"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M194.28,208.57,186,206.5l-10.54-12.38c3.35-5.49,1.34-15.68,12.53-14.3l4.13,2.06,2.25,10.17ZM188,190.12,187,188.63l1.11,1.47,2.08,2.66.61-.67Z",
    transform: "translate(0)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M194.4,192.05l-2.25-10.17,4.58-4.3,4.1.17,2.08,0q2.13,8.06,4.27,16.12Z",
    transform: "translate(0)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M207.18,193.9q-2.15-8.06-4.27-16.12l7.69.48Z",
    transform: "translate(0)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165.21,147.42,168,151l5.53,10.46-15,6-24.31-11.64c-7.54-7.69.5-10.73,4.47-15l6.31-1.74-.18,7.89-1.33,1.3,1.06.72c.15-.62.3-1.25.44-1.87,5.29-2.39,2,21.7,12.28,3.95l-.11.11Zm-6.51,9.82-2.89,3.24c.88.1,1.87.51,2.59.23s1.39-1.27,2.07-2Z",
    transform: "translate(0)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M144.88,147l.18-7.89,4.14-1.56,6,1.16,5.63,3.25,2.61,2.95c.55.79,1.1,1.57,1.66,2.35l.09.19-8,3.76c-.42-1.36-.85-2.72-1.27-4.08L154,148.51l3.33,2.56c-10.23,17.75-7-6.34-12.28-3.95Z",
    transform: "translate(0)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M117.9,120.13c0-1.31,0-2.61,0-3.92l8.28-13.65q-2.13,11-4.28,22Z",
    transform: "translate(0)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M138.75,140.82c-4,4.26-12,7.3-4.46,15l-3.41,5.44-6-12.19C127.55,143.06,130.32,137.15,138.75,140.82Z",
    transform: "translate(0)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M126.19,102.56l-8.28,13.65c-.44-.08-.88-.14-1.32-.19-.13-3.32-.27-6.63-.4-9.94L122,91.47l6,2.21Q127.13,98.12,126.19,102.56Z",
    transform: "translate(0)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M155.22,138.68l-6-1.16q1.22-6.63,2.45-13.27l8.86,2.71-3.21,5.73C156.6,134.69,155.91,136.68,155.22,138.68Z",
    transform: "translate(0)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128,93.68l-6-2.21Z",
    transform: "translate(0)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M309.14,448.6,319.28,446c-3.38-5.13-6.87-10.44-10.36-15.76l.31-.35,8.06,2.19.1.08,1.82.05.2-.19,10.09-3.78c10.12,2.26,9.1,8.82,6.2,16.09v0l-4.22,4-14.25,6.23Z",
    transform: "translate(0)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M309.14,448.6l8.09,5.93c-1.35,8.78-5.2,7.43-10,2.46Z",
    transform: "translate(0)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M331.48,448.3l4.22-4Z",
    transform: "translate(0)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M238.39,280.33l-3.17-4.11,2.25,0C237.78,277.62,238.08,279,238.39,280.33Z",
    transform: "translate(0)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M193.07,592.25l4.24-2.26c-.34,1.4-.68,2.81-1,4.22Z",
    transform: "translate(0)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M342.12,401.15l1.79.8-2.11-.42Z",
    transform: "translate(0)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M247.59,419.8q.09,5.31.19,10.6c-2.75-1.54-5.57-6.22-8.71,6.1,1.18-11.54,1.75-17.2,2.33-22.86Z",
    transform: "translate(0)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M337.86,372.6c1.95.79,3.89,1.58-.08,0,.64,5.28.33,2.69,0,.1Z",
    transform: "translate(0)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M303,401.8l-6.22-4.52Z",
    transform: "translate(0)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M270.15,421.45l4,.69c.05,1.26.09,2.52.13,3.78l-.09.06Z",
    transform: "translate(0)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M292.8,409.83l-4.15.24c-.13-.76-.25-1.53-.37-2.29l.55-.5Z",
    transform: "translate(0)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M266.08,411.62c0,1.36,0,2.71,0,4.07C266.09,414.33,266.08,413,266.08,411.62Z",
    transform: "translate(0)"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "376.67 354.92 377.19 355.26 376.61 355.49 376.67 354.92"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "294.71 348.06 294.27 347.54 294.79 347.99 294.71 348.06"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "294.79 347.99 295.22 348.49 294.71 348.06 294.79 347.99"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M266,415.64l2.16,2.5Z",
    transform: "translate(0)"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "288.62 374.66 289.08 375.17 288.56 374.71 288.62 374.66"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M538.87,317.27l3,.34-.45,1.14-2.56-1.5Z",
    transform: "translate(0)"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "557.23 307.09 556.81 306.49 557.42 306.9 557.23 307.09"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.43,243.15l-10.77-16h.26c.43-1.56.87-3.11,1.3-4.67l2.56-.23,9.62-15.81C91.25,211.12,100,216.57,110,209q2.1,9.58,4.21,19.18l.11-.12-8.26,2.8-.25-2.39c-4.34-3.06-8.5-6.44-13.14-8.92-1.13-.6-3.86,1.81-5.85,2.84L100,228,85.5,233.13c-.61-.06-1.23-.14-1.84-.23l-4.36-3.8q-1-2-2.06-4.07l-.45-.52.55.42,2,4.13q1.65,2.53,3.29,5.07l4.91,7.29-.06-.06c-.11.66-.21,1.33-.32,2Z",
    transform: "translate(0)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M114.32,228.05l-.11.12,16.23,3.32,6-.54,8.17-3.9q-4.89,8.2-9.77,16.4c-4.7-2.12-8.5-11.63-14.65-1.77-1.79-4.61-1.9-11.82-10.11-6.58Z",
    transform: "translate(0)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M174.25,252.05l-17.09,1.86-7.88.59,0-8.93,28.51-2.11,0-.05Z",
    transform: "translate(0)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M87.16,243.36c.11-.67.21-1.34.32-2l.06.06-4.9-7.29c.35-.41.68-.82,1-1.23.61.09,1.23.17,1.84.23L99,235.64l6,1.09a1,1,0,0,0,1,.71l.31,8.32Z",
    transform: "translate(0)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.25,245.76c-.11-2.77-.21-5.55-.31-8.32l2-1.67,2.18-.67c8.21-5.24,8.32,2,10.11,6.58Z",
    transform: "translate(0)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M134.87,243.45l9.77-16.39-3.94-2.22L147,218.7l-.09,14.08.15,4.57q-3,6.78-6.05,13.57Z",
    transform: "translate(0)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M142.91,275.93,130.8,287.49c-.29-2.39-.57-4.77-.86-7.16C135.17,281.54,133.69,263,142.91,275.93Z",
    transform: "translate(0)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M141,250.92q3-6.78,6.05-13.57h2c.1,2.74.21,5.49.31,8.23l0,8.93Z",
    transform: "translate(0)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M146.35,290.53q.22,2.79.44,5.6l-3.71.81Z",
    transform: "translate(0)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M151,265.92l-.18,3.66-2.34-1.29Z",
    transform: "translate(0)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M155,262.12l-3.95,3.78Z",
    transform: "translate(0)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M155.2,272.23l1.9,1-1.6.5A10,10,0,0,0,155.2,272.23Z",
    transform: "translate(0)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M87.66,262l-2.06,2-.21-.2,2-2.07Z",
    transform: "translate(0)"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "87.43 261.76 88.12 261.31 87.66 261.99 87.43 261.76"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M134.74,292.63l-2,2Z",
    transform: "translate(0)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.53,363.15c-.84,4.56-1.34,9.65-8,5.23l-4.21-3.92.09.09-4.08-5.75,16,1.51C253.37,361.26,253.45,362.21,253.53,363.15Z",
    transform: "translate(0)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250.45,352.24q1.08-6,2.17-12l3.22.52L254,352.32Z",
    transform: "translate(0)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M237.29,358.8l4.08,5.75-6.8-3.71Z",
    transform: "translate(0)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M241.28,364.46l4.21,3.92-4.12.12.06.06Z",
    transform: "translate(0)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M222.73,304.67l3.44-2.58Z",
    transform: "translate(0)"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "261.93 333.64 261.51 333.24 261.89 333.68 261.93 333.64"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "261.89 333.68 262.35 334.07 261.93 333.64 261.89 333.68"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M253.53,363.15c-.08-.94-.16-1.89-.25-2.84C253.37,361.26,253.45,362.21,253.53,363.15Z",
    transform: "translate(0)"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "239.32 286.51 239.73 286.85 239.36 286.47 239.32 286.51"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M224.8,397.44a9.89,9.89,0,0,1-1.7-.36l16.46-3.85-6.27,12.18-2.17,0,.1.05c-.14-1.25-.27-2.51-.4-3.77Z",
    transform: "translate(0)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M234.07,443.48c.24-3.59-12.85-7.06-.11-10.77l.53-.08,3.89,7.78-.95,0L236,441.79C235.33,442.36,234.7,442.92,234.07,443.48Z",
    transform: "translate(0)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M294.66,335.82l-2.16-2,1.14-.84,1.24,2.65Z",
    transform: "translate(0)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M234.49,432.63l-.53.08c.37-1.49.72-3,1.08-4.47C234.86,429.71,234.67,431.17,234.49,432.63Z",
    transform: "translate(0)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M247.76,438a17.71,17.71,0,0,0-.31-1.77c.05-.92.11-1.84.17-2.77l1.92,2.78Z",
    transform: "translate(0)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M229.16,370.56l4.54,2.06Z",
    transform: "translate(0)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M296.68,337.91l-2-2.09.22-.21,2.07,2Z",
    transform: "translate(0)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M297,337.64l2,2.07-.19.19-2.05-2Z",
    transform: "translate(0)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M264.37,357.94l.41.67h-1.09Z",
    transform: "translate(0)"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "284.46 329.58 284.93 329.99 284.5 329.54 284.46 329.58"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M231.12,405.37l2.17,0Z",
    transform: "translate(0)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M239.93,446.68l-.63,3.77-5.23-7L236,441.8l1,.08,1-.1,2,2.36Z",
    transform: "translate(0)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M224.8,397.44l6,4.21Z",
    transform: "translate(0)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M149.31,245.57c-.1-2.74-.21-5.49-.31-8.23.59-1.77,1.17-3.53,1.76-5.29l.48-7.08,2.32-2.17c.56.17,1.13.34,1.69.49a4.22,4.22,0,0,0,.15,1.66l4.32,12,1.55.39,1.41-2.48q4.4-5.88,8.77-11.77l.42-.38c13.64.27,29-4.46,37,12.46v6.3L205,243.84l-6.66-4.6-.68-.3.56.43c-1.8,6.13-23.13-6.88-11.84,12.08l-12.18.6q1.77-4.32,3.53-8.64l.39-.36-.34.41ZM172,235.19l1.19,3.13c2.79-1.47,5.62-2.87,8.31-4.5.26-.15-.37-1.75-.59-2.68Z",
    transform: "translate(0)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M186.42,251.45c-11.29-19,10-5.95,11.84-12.08l.13-.13,6.65,4.6-.23-.06-2.59,1.9-2.59,1.39q-2.92,1.92-5.84,3.85l-5.69,1.81Z",
    transform: "translate(0)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M165.22,267.3c1.7-9.68,7.95-7.81,14.32-5.65.12,1.46.23,2.92.35,4.37-8.77.32-3.83,3.89-1.62,6.81l-11-4.79Z",
    transform: "translate(0)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M179.89,266c-.12-1.45-.23-2.91-.35-4.37a20.41,20.41,0,0,0,2-.4l8.32,2.56L184,268.3l-4.16-2.36Z",
    transform: "translate(0)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M178.27,272.83c-2.21-2.92-7.15-6.49,1.62-6.81l-.08-.08q1.13,2.08,2.26,4.16Z",
    transform: "translate(0)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M170,280.38l5.79,6.12h0l-6.63-2.63Z",
    transform: "translate(0)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M170,280.38l-.84,3.48-4.63-.38Z",
    transform: "translate(0)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M182.07,270.1q-1.14-2.07-2.26-4.16L184,268.3Z",
    transform: "translate(0)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M165.22,267.3l2.05.74-1.41,2.08C165.64,269.18,165.43,268.24,165.22,267.3Z",
    transform: "translate(0)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M167.05,293.85l.22-.67.47.94Z",
    transform: "translate(0)"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "200.34 382.9 200.8 383.35 200.39 382.86 200.34 382.9"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M110,209c-10,7.58-18.75,2.13-27.6-2.54q-2.78-4.11-5.54-8.21L76,191.68l4-1.48-3-2.08,5-9.26,25.94-5.72c12.39,8.59,17,19,7.66,32.67Z",
    transform: "translate(0)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M130.88,161.25l3.41-5.44,24.31,11.64,3.1,1.84q-2.22,9.36-4.42,18.73l-5,4.39c.22,2.45.43,4.91.65,7.36A5.74,5.74,0,0,0,151,200l-4.7-.11,2.19,2.7-7.35,1.72-2.85-23.12,7.41,5.24L143,173.61l-10.45-8Z",
    transform: "translate(0)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M107.94,173.14,82,178.86l1.11-10.42,2.62-2.6,1.66-.78,18.69-9.71c2.09,10-6.37,10.27-15.47,14.11Z",
    transform: "translate(0)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M141.1,204.3l7.36-1.72L151,200a5.77,5.77,0,0,1,1.94-.22c.09.82.19,1.63.28,2.44l.24,5.78,4,5c0,1.28-.05,2.55-.07,3.83l-2.07,6.49-1.7-.5-2.4-5.65L147,218.7l-6.27,6.14a2.61,2.61,0,0,1-1.27.9Q140.26,215,141.1,204.3Z",
    transform: "translate(0)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M110,209l5.6-3.18q7.43,12.84,14.84,25.68l-16.23-3.32Q112.11,218.57,110,209Z",
    transform: "translate(0)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.53,165.62l10.45,8-4.74,7.63Q135.38,173.43,132.53,165.62Z",
    transform: "translate(0)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M138.24,181.24l4.74-7.63q1.34,6.4,2.68,12.81l-7.41-5.24Z",
    transform: "translate(0)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.43,225.74a2.61,2.61,0,0,0,1.27-.9l3.94,2.22L136.47,231C137.45,229.21,138.44,227.48,139.43,225.74Z",
    transform: "translate(0)"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "110.46 168.69 109.67 168.95 109.77 168.22 110.46 168.69"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M87.39,165.06l-1.66.78A2.52,2.52,0,0,1,87.39,165.06Z",
    transform: "translate(0)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M76.86,198.24q2.77,4.09,5.54,8.21l-9.62,15.81Z",
    transform: "translate(0)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M77.05,188.12l3,2.08-4,1.48Z",
    transform: "translate(0)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M70.22,222.49c-.43,1.56-.87,3.11-1.3,4.67-.74-.13-1.47-.25-2.2-.39l.72-6.07Z",
    transform: "translate(0)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M173.57,161.41,168,151l18.07,10.15,4,.32,4.77-6.93,3,10.91-1.77,10.49c.21.57.43,1.13.68,1.69l-4.58,4.3L188,179.82l-12.27-12.43Q174.66,164.41,173.57,161.41Z",
    transform: "translate(0)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M197.82,165.4l-3-10.91c-.57-2.48-1.15-5-1.73-7.45,7.56,5.2,13.67,10.8,5.49,20.27C198.34,166.67,198.08,166,197.82,165.4Z",
    transform: "translate(0)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M155.22,138.68c.69-2,1.38-4,2.08-6q1.77,4.62,3.55,9.24Z",
    transform: "translate(0)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M190.08,161.42l-4-.32Z",
    transform: "translate(0)"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "167.59 128.52 168.03 129.08 167.47 128.63 167.59 128.52"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165.12,147.23c-.56-.78-1.11-1.56-1.66-2.35C164,145.67,164.56,146.45,165.12,147.23Z",
    transform: "translate(0)"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "167.47 128.63 167.02 128.08 167.59 128.52 167.47 128.63"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M197.82,165.4c.26.64.52,1.27.79,1.91-.85,2.86-1.71,5.72-2.56,8.58Z",
    transform: "translate(0)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M247.76,438l1.78-1.76c12,2.93-.44,9.74,2.25,14.15l-8.15.29Q245.7,444.38,247.76,438Z",
    transform: "translate(0)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M238,441.78l-1,.1-1-.08,1.48-1.43A1.54,1.54,0,0,1,238,441.78Z",
    transform: "translate(0)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M239.93,446.68v-2.54a10.71,10.71,0,0,1,.44,1.73C240.4,446.12,240.09,446.41,239.93,446.68Z",
    transform: "translate(0)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M175.49,194.12,186,206.5l-6.13,2.06-3.48-4-1.2-.25.66.72c-.12,1.92-.24,3.83-.37,5.75h-.8l-.79-.08-6.4-5.83c0-1,0-2,0-2.93l4.14-4.19,3.77-1.81C175.45,195.36,175.48,194.74,175.49,194.12Z",
    transform: "translate(0)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M153.42,208l-.24-5.78,4.18.21,6.1,3.79,4.78,7-.62,5.72h0l-10.29-2.07c0-1.28,0-2.55.07-3.83Z",
    transform: "translate(0)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M168.24,213.17l-4.78-7,4.06-1.3,6.4,5.83Z",
    transform: "translate(0)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M175.51,210.81c.13-1.92.25-3.83.37-5.75l.54-.47,3.48,4c-.67,1.62-1.35,3.23-2,4.85Z",
    transform: "translate(0)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M167.62,218.89l4.24,3.82-.41.38q-1.9-2.11-3.83-4.21Z",
    transform: "translate(0)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M193.79,250.92q2.91-1.93,5.84-3.85Z",
    transform: "translate(0)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M202.22,245.68l2.59-1.9Z",
    transform: "translate(0)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M214.14,308.47,212.7,307Z",
    transform: "translate(0)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M171.64,197.79,167.5,202l-7.87.11-7.39-9.68,5-4.39c17.17,4.53,13.95-9.75,16.91-18.33l1.56-2.3L188,179.82c-11.19-1.38-9.18,8.81-12.53,14.3,0,.62,0,1.24-.07,1.86Z",
    transform: "translate(0)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M188,190.12l2.72,2-.61.67-2.08-2.66Z",
    transform: "translate(0)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M188.07,190.1,187,188.63l1.08,1.49Z",
    transform: "translate(0)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M175.75,167.39l-1.56,2.3-6.65-.09-5.84-.31-3.1-1.84,15-6Q174.65,164.41,175.75,167.39Z",
    transform: "translate(0)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M158.7,157.24l1.77,1.52c-.68.68-1.25,1.62-2.07,2s-1.71-.13-2.59-.23Z",
    transform: "translate(0)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M145.05,147.12c-.14.62-.29,1.25-.44,1.87l-1.06-.72,1.33-1.3Z",
    transform: "translate(0)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M157.33,151.07,154,148.51,156,147.1c.42,1.36.85,2.72,1.27,4.08Z",
    transform: "translate(0)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M274.27,425.92c0-1.26-.08-2.52-.13-3.78l18.67-6.39q4.11,7.11,8.21,14.22l-.23.24Z",
    transform: "translate(0)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M292.8,409.83l-4-2.55q.94-3,1.88-5.91l6.23,10.12-.27.27Z",
    transform: "translate(0)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M308.92,430.23l-4.63-3.07,1.46-1.74,3.48,4.46Z",
    transform: "translate(0)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M284.47,397.23l4.41.09c.59,1.32,1.17,2.63,1.75,3.95Z",
    transform: "translate(0)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M301,430l2,2.07-.19.18-2.07-2Z",
    transform: "translate(0)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M317.29,432.07l2.12-.06-.2.19c-.61,0-1.21,0-1.82-.05Z",
    transform: "translate(0)"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "303.05 432.04 303.45 432.62 302.87 432.22 303.05 432.04"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "296.94 411.49 297.35 412.17 296.67 411.76 296.94 411.49"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M317.39,432.15c.61,0,1.21,0,1.82.05Z",
    transform: "translate(0)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M497.41,323c5.38-9.08-1.47-15.2-11.78-15.81-3.88,14.15-12.87,21.6-23.74,26.39q-2.34,1-4.77,1.9,2.43-.87,4.77-1.9c10.87-4.79,19.86-12.24,23.74-26.39-10.42.25-18.61,1.41-29.28-7.57-15.33-12.89-36-8.78-51.26,6.42-9.53,9.46-24.48,19.33-25.56,30.15-1.9,19.06-14.15,23.53-26.37,25.24-9.12,1.26-13.46,2.83-15.3,11.21l.56.23-.64-.26c.2,1.67.31,2.55.35,2.89-.05-.42-.19-1.6-.34-2.79-5.39,6.83-12,9.67-20.47,6.13q.21,7.43.41,14.86l-12.39-8.73L298.59,379l10.49-.19.06-.08.39-18.72q-2.31-4.9-4.6-9.81-1-5.19-2-10.39l-4-.12-.19.2c-10,5.83-31.7,1-22.49,24.5l12.37,10.26.46.51-.52-.46.06,0L276.25,364.4l0,6.18-6.79-2.23L282.93,381c-7.06,8.88-8.45,8.84-12.35-.34-13.65,27.41-20.31,33-31.59,24.49,1,3.64,1.72,6.06,2.41,8.49l6.19,6.16c16.49-16.74,15.54,9.53,25,10.14h0c-.66,22.79,26.71,11.49,32.37,26.6l2.32.45,1.86-8.39L319.28,446c-3.38-5.13-6.87-10.44-10.36-15.76l-4.63-3.07,1.46-1.74,3.48,4.46,8.06,2.19,2.12-.06,10.08-3.78h0c10.12,2.26,9.1,8.82,6.2,16.09l14-5.94,4.71-2.43q4-4.92,8.09-9.82c14.85,2.86,35.7-15.3,43.45,12.4,10,22.11,16-2,24-2.16,9.55-15.18,21.06-28,39.23-33l4-4c5.65-8.74-2-33.64,23-18.91l7.89-10C503.11,354.61,486.44,341.5,497.41,323ZM303,401.8l-6.22-4.52h0Zm-20.5-6.6,2,2,4.41.09h0l1.74,3.95-6.15-4h0l-2-2Zm6.2,14.87h0c-.13-.76-.25-1.53-.37-2.29h0l.56-.5c.62-2,1.25-3.94,1.87-5.91l0-.05,0,.05,6.23,10.12.41.68-.68-.41-3.87-1.93ZM294.79,348l.43.5-.51-.43-.44-.52Zm-28.7,67.7h0c0-1.36,0-2.71,0-4.07C266.08,413,266.09,414.33,266.09,415.69Zm36.77,16.53-2.07-2-26.52-4.29-.09.06c-.05.15-.11.29-.17.44l.17-.44-4-4.53c-.65-1.1-1.31-2.2-2-3.31l-2.16-2.5,2.16,2.5c.65,1.11,1.31,2.21,2,3.31l4,.69,18.67-6.39-1.58-.82,1.58.82q4.11,7.11,8.21,14.22l2,2.07.4.58Zm37.05-58.79Zm0,31.75a18,18,0,0,0,1.88-3.65h0A18,18,0,0,1,339.91,405.18Zm1.89-3.65.32-.38,1.79.8Zm34.81-46,.06-.57.53.34Z",
    transform: "translate(0)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M100,228l-13.16-5.59c2-1,4.72-3.44,5.85-2.84,4.64,2.48,8.8,5.86,13.14,8.92Z",
    transform: "translate(0)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M100,228l5.83.49c.08.8.16,1.59.25,2.39l-7,4.79L85.5,233.13Z",
    transform: "translate(0)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M99,235.64l7-4.79,8.26-2.8-4.21,7c-.73.22-1.45.45-2.18.66l-3,1Z",
    transform: "translate(0)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M79.3,229.1l4.36,3.8c-.34.41-.67.82-1,1.23l-3.3-5.07Z",
    transform: "translate(0)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M79.34,229.06l-2-4.13-.1.1q1,2,2.06,4.07Z",
    transform: "translate(0)"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "77.34 224.93 76.79 224.51 77.24 225.03 77.34 224.93"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.54,241.42l-.06-.06Z",
    transform: "translate(0)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M105,236.73l3-1-2,1.68A1,1,0,0,1,105,236.73Z",
    transform: "translate(0)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M147,218.7l4.19-1.55c0,2.61.05,5.21.08,7.82l-.48,7.07-3.88.74Z",
    transform: "translate(0)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M146.88,232.78l3.88-.74-1.76,5.3h-2Z",
    transform: "translate(0)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M167.62,218.88q1.92,2.1,3.83,4.21l-8.76,11.77L155.4,225a4.22,4.22,0,0,1-.15-1.66q1-3.24,2.08-6.48Z",
    transform: "translate(0)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M155.4,225l7.29,9.91-1.42,2.48a5.19,5.19,0,0,0-1.55-.39Z",
    transform: "translate(0)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172,235.19l8.91-4.05c.22.93.85,2.53.59,2.68-2.69,1.63-5.52,3-8.31,4.5Z",
    transform: "translate(0)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.24,225c0-2.61-.06-5.21-.08-7.82l2.4,5.65Z",
    transform: "translate(0)"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "177.82 243.46 178.16 243.05 177.77 243.41 177.82 243.46"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M159.72,237a5.19,5.19,0,0,1,1.55.39Z",
    transform: "translate(0)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M198.26,239.37l-.56-.43.68.3Z",
    transform: "translate(0)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M161.7,169.29c1.94.1,3.89.21,6,.15-.73.69-.82.74-.81.77,0,.36.09.72.14,1.07.11-.27.23-.53.67-1.84,2,.19,4.25.22,6.47.25-3,8.58.26,22.86-16.91,18.33Q159.49,178.66,161.7,169.29Z",
    transform: "translate(0)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M152.24,192.41l7.39,9.69-2.27.32-4.18-.21c-.09-.81-.19-1.62-.28-2.44C152.67,197.32,152.46,194.86,152.24,192.41Z",
    transform: "translate(0)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M151,200l-2.5,2.59-2.2-2.7Z",
    transform: "translate(0)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M153.42,208l4,5Z",
    transform: "translate(0)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M157.36,202.42l2.27-.32,7.87-.12c0,1,0,2,0,2.93l-4.06,1.3Z",
    transform: "translate(0)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M171.64,197.79l3.78-1.81Z",
    transform: "translate(0)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M175.88,205.06l-.66-.72,1.2.25Z",
    transform: "translate(0)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M167.89,169.29l-.84,2c-.05-.35-.11-.71-.14-1.07A10.06,10.06,0,0,1,167.89,169.29Z",
    transform: "translate(0)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorgi404);
export default __webpack_public_path__ + "static/media/corgi_404.7678d272d8ba3d05fc7835a82b7148e6.svg";
export { ForwardRef as ReactComponent };